'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _AuthLine = require('./AuthLine');

var _AuthLine2 = _interopRequireDefault(_AuthLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AuthBody(props) {
  var actions = props.actions,
      spliter = props.spliter,
      emptyAuth = props.emptyAuth,
      value = props.value;

  return value ? _react2.default.createElement(
    'tbody',
    null,
    Object.keys(emptyAuth || {}).map(function (name, index) {
      return _react2.default.createElement(_AuthLine2.default, _extends({
        key: index,
        name: name,
        actions: actions
      }, spliter(props)(name)));
    })
  ) : null;
}
AuthBody.propTypes = {
  schema: _propTypes.object.isRequired,
  actions: _propTypes.array.isRequired,
  spliter: _propTypes.func.isRequired,
  emptyAuth: _propTypes.object,
  value: _propTypes.object
};

exports.default = AuthBody;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/GroupEditor/AuthEditor/AuthBody/AuthBody.js
// module id = 1783
// module chunks = 0